import { useState } from "react";
import { ICellRendererParams } from "ag-grid-community";

import { XCircleIcon } from "../Icons";
import CustomModal from "./CustomModal";

export default function RowDeleteBtn(
  params: ICellRendererParams & { handleSave: () => void }
) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");

  const REQUIRED_TEXT = "DELETE";
  const isConfirmed = confirmText === REQUIRED_TEXT;

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const handleDelete = () => {
    if (confirmText !== "DELETE") return;

    params.api.applyTransaction({ remove: [params.data] });

    params.handleSave?.();
    toggleModal();
  };

  return (
    <div>
      <button
        onClick={toggleModal}
        className="mt-2 text-red-500 hover:scale-90"
        title="Delete this row"
      >
        <XCircleIcon />
      </button>

      <CustomModal open={isModalOpen} onClose={toggleModal}>
        <div className="space-y-4">
          <h1 className="font-medium text-xl text-gray-950">
            ⚠️ You are about to delete important data.
          </h1>
          <p className="text-sm text-gray-900">
            Please confirm that you want to permanently remove this item.
          </p>

          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder={`Type "${REQUIRED_TEXT}" to confirm`}
            className="input-new"
          />

          <div className="flex gap-4">
            <button
              className={`w-full p-2 rounded-xl text-white 
              ${
                isConfirmed
                  ? "bg-red-500 cursor-pointer"
                  : "bg-red-300 cursor-not-allowed"
              }`}
              disabled={!isConfirmed}
              onClick={handleDelete}
            >
              Yes, Delete
            </button>
            <button
              className="w-full text-gray-900 p-2 cursor-pointer border border-gray-900 rounded-xl"
              onClick={toggleModal}
            >
              No
            </button>
          </div>
        </div>
      </CustomModal>
    </div>
  );
}
